/**
 * BrokerSection — "(e) broker choice" on the one-page Confirm & book.
 * Radio: Prime Freight handles customs (recommended, $75) / I have my own
 * broker (+ name field). Same $75 fee rule as the legacy flow
 * (util/getBookingInfo.PRIME_FREIGHT_BROKERAGE_FEE).
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Radio } from 'antd';
import { BrokerOption } from '../../../util/publicBookingPayload';
import { PRIME_FREIGHT_BROKERAGE_FEE } from '../../../util/getBookingInfo';
import {
  SectionCard,
  SectionHeading,
  SectionHint,
  fieldLabelStyle,
} from './confirmTheme';

const label = (text) => <span style={fieldLabelStyle}>{text}</span>;

const radioStyle = {
  display: 'block',
  minHeight: '32px',
  lineHeight: '32px',
  whiteSpace: 'normal',
};

const BrokerSection = ({ form }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const option = getFieldValue('broker_option') || BrokerOption.PRIME_FREIGHT;

  return (
    <SectionCard aria-label="Customs broker">
      <SectionHeading>Customs broker</SectionHeading>
      <SectionHint>Who clears this shipment through customs?</SectionHint>

      <Form.Item colon={false}>
        {getFieldDecorator('broker_option', {
          initialValue: BrokerOption.PRIME_FREIGHT,
          rules: [{ required: true, message: 'Please pick a customs option.' }],
        })(
          <Radio.Group name="broker_option">
            <Radio style={radioStyle} value={BrokerOption.PRIME_FREIGHT}>
              Prime Freight handles customs (recommended, +$
              {PRIME_FREIGHT_BROKERAGE_FEE})
            </Radio>
            <Radio style={radioStyle} value={BrokerOption.OTHER}>
              I have my own broker
            </Radio>
          </Radio.Group>
        )}
      </Form.Item>

      {option === BrokerOption.OTHER && (
        <Form.Item label={label('Broker name')} colon={false}>
          {getFieldDecorator('broker_name', {
            validateTrigger: 'onBlur',
            rules: [{ required: true, message: 'Please add your broker’s name.' }],
          })(<Input size="large" placeholder="Broker name" style={{ maxWidth: 360 }} />)}
        </Form.Item>
      )}
    </SectionCard>
  );
};

BrokerSection.propTypes = {
  form: PropTypes.object.isRequired,
};

export default BrokerSection;
